import React from "react";
import { ContentWrapper } from "../../../../../../shared/styled/TableStyles";
import { TitleRow } from "../../../Content/LineChart/Styled";
import { LineGraphIcon } from "../../../../../../shared/svg/LineGraphIcon";
import { LineChartComponent, LineChartData } from "../../../Content/LineChart";
import { api } from "../../../../../../shared/hooks/api";
import PageLoader from "../../../../../../shared/components/LoadingPage";
import { formatCurrency } from "../../../../../../utils/format";
import { color } from "../../../../../../shared/styles";

const processMonthlyRevenue = (monthly_revenue: any): LineChartData[] => {
    const processedData: LineChartData[] = [];

    Object.keys(monthly_revenue).forEach((month: string) => {
        const monthString = `Tháng ${month}`;
        processedData.push({
            name: monthString,
            "Doanh thu": monthly_revenue[month],
        });
    });

    return processedData;
};

export const RevenueLineGraph = () => {
    const currentYear = new Date().getFullYear();
    const [{ data, error, isLoading }, fetchRevenueData] = api.get("/products/orders/revenue/", {
        year: currentYear,
    });

    if (isLoading) return <PageLoader />;

    const { total_revenue, monthly_revenue, kpi_revenue } = data;

    const processedMonthlyRevenue = processMonthlyRevenue(monthly_revenue);

    return (
        <ContentWrapper>
            <TitleRow>
                <LineGraphIcon />
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <span style={{ fontSize: "14.486px", color: "#9A9A9A" }}>
                        Doanh thu năm {currentYear}
                    </span>
                    <div style={{ display: "inline-flex", alignItems: "baseline" }}>
                        <span
                            style={{
                                fontSize: "32px",
                                fontWeight: 600,
                                color:
                                    total_revenue >= kpi_revenue
                                        ? color.status.SUCCESS
                                        : color.status.FAIL,
                            }}
                        >
                            {formatCurrency(total_revenue)}
                        </span>
                        <span style={{ fontSize: "32px", fontWeight: 600 }}>
                            &nbsp;/&nbsp;{formatCurrency(kpi_revenue)}
                        </span>
                    </div>
                </div>
            </TitleRow>
            <LineChartComponent data={processedMonthlyRevenue} />
        </ContentWrapper>
    );
};
